var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GhostInput',_vm._g(_vm._b({ref:"ghostInput",staticClass:"name"},'GhostInput',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }